function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  width: 235,
  height: 74,
  y: 25,
  fill: "#e679b1",
  fillOpacity: 0.1,
  rx: 10
}), React.createElement("rect", {
  width: 214,
  height: 49,
  x: 74,
  y: 319,
  fill: "#e679b1",
  fillOpacity: 0.1,
  rx: 10
}), React.createElement("rect", {
  width: 214,
  height: 99,
  x: 646,
  fill: "#e679b1",
  fillOpacity: 0.1,
  rx: 10
}), React.createElement("rect", {
  width: 170,
  height: 49,
  x: 788,
  y: 319,
  fill: "#e679b1",
  fillOpacity: 0.1,
  rx: 10
}), React.createElement("rect", {
  width: 137,
  height: 49,
  x: 255,
  y: 50,
  fill: "#99D8F1",
  fillOpacity: 0.1,
  rx: 10
}), React.createElement("rect", {
  width: 202,
  height: 49,
  x: 308,
  y: 319,
  fill: "#99D8F1",
  fillOpacity: 0.1,
  rx: 10
}), React.createElement("rect", {
  width: 207,
  height: 74,
  x: 880,
  y: 25,
  fill: "#99D8F1",
  fillOpacity: 0.1,
  rx: 10
}), React.createElement("rect", {
  width: 198,
  height: 99,
  x: 978,
  y: 319,
  fill: "#99D8F1",
  fillOpacity: 0.1,
  rx: 10
}), React.createElement("rect", {
  width: 214,
  height: 99,
  x: 412,
  fill: "#E1D0FF",
  fillOpacity: 0.1,
  rx: 10
}), React.createElement("rect", {
  width: 238,
  height: 99,
  x: 530,
  y: 319,
  fill: "#E1D0FF",
  fillOpacity: 0.1,
  rx: 10
}), React.createElement("g", {
  fill: "#e679b1"
}, React.createElement("path", {
  d: "M170 201.938A8.001 8.001 0 0 1 171 186a8 8 0 0 1 1 15.938V206a1 1 0 0 1-2 0v-4.062z",
  opacity: 0.9
}), React.createElement("path", {
  d: "M155 191.93a7.002 7.002 0 0 1 1-13.93 7 7 0 0 1 1 13.93V206a1 1 0 0 1-2 0v-14.07z",
  opacity: 0.8
}), React.createElement("path", {
  d: "M140 185.917A6.002 6.002 0 0 1 141 174a6 6 0 0 1 1 11.917V206a1 1 0 0 1-2 0v-20.083z",
  opacity: 0.7
}), React.createElement("path", {
  d: "M125 185.9a5.002 5.002 0 0 1 1-9.9 5 5 0 0 1 1 9.9V206a1 1 0 0 1-2 0v-20.1z",
  opacity: 0.6
}), React.createElement("path", {
  d: "M110.008 188.876A4.002 4.002 0 0 1 111 181a4 4 0 0 1 .992 7.876c.005.04.008.082.008.124v17a1 1 0 0 1-2 0v-17c0-.042.003-.083.008-.124z",
  opacity: 0.5
}), React.createElement("path", {
  d: "M95 193.83a3.001 3.001 0 1 1 2 0V206a1 1 0 0 1-2 0v-12.17z",
  opacity: 0.4
})), React.createElement("path", {
  fill: "#e679b1",
  d: "M80 200.055V199a1 1 0 0 1 2 0v1.055A9.001 9.001 0 0 1 81 218a9 9 0 0 1-1-17.945zM81 139a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0 53a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-20a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-21a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-24a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0 52a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-21a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-25a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-18a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1zm0 71a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-21a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-20a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-24a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1z"
}), React.createElement("g", {
  fill: "#e679b1"
}, React.createElement("path", {
  d: "M202 216.062A8.001 8.001 0 0 1 201 232a8 8 0 0 1-1-15.938V212a1 1 0 0 1 2 0v4.062z",
  opacity: 0.9
}), React.createElement("path", {
  d: "M217 226.07a7.002 7.002 0 0 1-1 13.93 7 7 0 0 1-1-13.93V212a1 1 0 0 1 2 0v14.07z",
  opacity: 0.8
}), React.createElement("path", {
  d: "M232 232.083A6.002 6.002 0 0 1 231 244a6 6 0 0 1-1-11.917V212a1 1 0 0 1 2 0v20.083z",
  opacity: 0.7
}), React.createElement("path", {
  d: "M247 232.1a5.002 5.002 0 0 1-1 9.9 5 5 0 0 1-1-9.9V212a1 1 0 0 1 2 0v20.1z",
  opacity: 0.6
}), React.createElement("path", {
  d: "M261.992 229.124A4.002 4.002 0 0 1 261 237a4 4 0 0 1-.992-7.876A1.01 1.01 0 0 1 260 229v-17a1 1 0 0 1 2 0v17c0 .042-.003.083-.008.124z",
  opacity: 0.5
}), React.createElement("path", {
  d: "M277 224.17a3.001 3.001 0 1 1-2 0V212a1 1 0 0 1 2 0v12.17z",
  opacity: 0.4
})), React.createElement("path", {
  fill: "#e679b1",
  d: "M185 217.945V219a1 1 0 1 0 2 0v-1.055A9.001 9.001 0 0 0 186 200a9 9 0 0 0-1 17.945zM186 279a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0-53a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 20a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 21a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 24a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0-52a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 21a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 25a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 18a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0-71a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 21a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 20a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 24a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1z"
}), React.createElement("g", {
  fill: "#E6E9EB"
}, React.createElement("path", {
  d: "M95 216.062A8.001 8.001 0 0 0 96 232a8 8 0 0 0 1-15.938V212a1 1 0 0 0-2 0v4.062z"
}), React.createElement("path", {
  d: "M110 226.07a7.002 7.002 0 0 0 1 13.93 7 7 0 0 0 1-13.93V212a1 1 0 0 0-2 0v14.07z",
  opacity: 0.9
}), React.createElement("path", {
  d: "M125 232.083A6.002 6.002 0 0 0 126 244a6 6 0 0 0 1-11.917V212a1 1 0 0 0-2 0v20.083z",
  opacity: 0.8
}), React.createElement("path", {
  d: "M140 232.1a5.002 5.002 0 0 0 1 9.9 5 5 0 0 0 1-9.9V212a1 1 0 0 0-2 0v20.1z",
  opacity: 0.7
}), React.createElement("path", {
  d: "M155.008 229.124A4.002 4.002 0 0 0 156 237a4 4 0 0 0 .992-7.876A1.01 1.01 0 0 0 157 229v-17a1 1 0 0 0-2 0v17c0 .042.003.083.008.124z",
  opacity: 0.6
}), React.createElement("path", {
  d: "M170 224.17a3.001 3.001 0 1 0 2 0V212a1 1 0 0 0-2 0v12.17z",
  opacity: 0.5
})), React.createElement("g", {
  fill: "#E6E9EB"
}, React.createElement("path", {
  d: "M277 201.938A8.001 8.001 0 0 0 276 186a8 8 0 0 0-1 15.938V206a1 1 0 0 0 2 0v-4.062z"
}), React.createElement("path", {
  d: "M262 191.93a7.002 7.002 0 0 0-1-13.93 7 7 0 0 0-1 13.93V206a1 1 0 0 0 2 0v-14.07z",
  opacity: 0.9
}), React.createElement("path", {
  d: "M247 185.917A6.002 6.002 0 0 0 246 174a6 6 0 0 0-1 11.917V206a1 1 0 0 0 2 0v-20.083z",
  opacity: 0.8
}), React.createElement("path", {
  d: "M232 185.9a5.002 5.002 0 0 0-1-9.9 5 5 0 0 0-1 9.9V206a1 1 0 0 0 2 0v-20.1z",
  opacity: 0.7
}), React.createElement("path", {
  d: "M216.992 188.876A4.002 4.002 0 0 0 216 181a4 4 0 0 0-.992 7.876A1.01 1.01 0 0 0 215 189v17a1 1 0 0 0 2 0v-17a1.01 1.01 0 0 0-.008-.124z",
  opacity: 0.6
}), React.createElement("path", {
  d: "M202 193.83a3.001 3.001 0 1 0-2 0V206a1 1 0 0 0 2 0v-12.17z",
  opacity: 0.5
})), React.createElement("g", {
  fill: "#e679b1"
}, React.createElement("path", {
  d: "M800 201.938A8.001 8.001 0 0 1 801 186a8 8 0 0 1 1 15.938V206a1 1 0 0 1-2 0v-4.062z",
  opacity: 0.9
}), React.createElement("path", {
  d: "M785 191.93a7.002 7.002 0 0 1 1-13.93 7 7 0 0 1 1 13.93V206a1 1 0 0 1-2 0v-14.07z",
  opacity: 0.8
}), React.createElement("path", {
  d: "M770 185.917A6.002 6.002 0 0 1 771 174a6 6 0 0 1 1 11.917V206a1 1 0 0 1-2 0v-20.083z",
  opacity: 0.7
}), React.createElement("path", {
  d: "M755 185.9a5.002 5.002 0 0 1 1-9.9 5 5 0 0 1 1 9.9V206a1 1 0 0 1-2 0v-20.1z",
  opacity: 0.6
}), React.createElement("path", {
  d: "M740.008 188.876A4.002 4.002 0 0 1 741 181a4 4 0 0 1 .992 7.876c.005.04.008.082.008.124v17a1 1 0 0 1-2 0v-17c0-.042.003-.083.008-.124z",
  opacity: 0.5
}), React.createElement("path", {
  d: "M725 193.83a3.001 3.001 0 1 1 2 0V206a1 1 0 0 1-2 0v-12.17z",
  opacity: 0.4
})), React.createElement("path", {
  fill: "#e679b1",
  d: "M710 200.055V199a1 1 0 0 1 2 0v1.055A9.001 9.001 0 0 1 711 218a9 9 0 0 1-1-17.945zM711 139a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0 53a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-20a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-21a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-24a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0 52a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-21a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-25a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-18a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1zm0 71a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-21a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-20a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-24a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1z"
}), React.createElement("g", {
  fill: "#e679b1"
}, React.createElement("path", {
  d: "M832 216.062A8.001 8.001 0 0 1 831 232a8 8 0 0 1-1-15.938V212a1 1 0 0 1 2 0v4.062z",
  opacity: 0.9
}), React.createElement("path", {
  d: "M847 226.07a7.002 7.002 0 0 1-1 13.93 7 7 0 0 1-1-13.93V212a1 1 0 0 1 2 0v14.07z",
  opacity: 0.8
}), React.createElement("path", {
  d: "M862 232.083A6.002 6.002 0 0 1 861 244a6 6 0 0 1-1-11.917V212a1 1 0 0 1 2 0v20.083z",
  opacity: 0.7
}), React.createElement("path", {
  d: "M877 232.1a5.002 5.002 0 0 1-1 9.9 5 5 0 0 1-1-9.9V212a1 1 0 0 1 2 0v20.1z",
  opacity: 0.6
}), React.createElement("path", {
  d: "M891.992 229.124A4.002 4.002 0 0 1 891 237a4 4 0 0 1-.992-7.876A1.01 1.01 0 0 1 890 229v-17a1 1 0 0 1 2 0v17c0 .042-.003.083-.008.124z",
  opacity: 0.5
}), React.createElement("path", {
  d: "M907 224.17a3.001 3.001 0 1 1-2 0V212a1 1 0 0 1 2 0v12.17z",
  opacity: 0.4
})), React.createElement("path", {
  fill: "#e679b1",
  d: "M815 217.945V219a1 1 0 1 0 2 0v-1.055A9.001 9.001 0 0 0 816 200a9 9 0 0 0-1 17.945zM816 279a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0-53a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 20a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 21a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 24a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0-52a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 21a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 25a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 18a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0-71a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 21a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 20a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 24a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1z"
}), React.createElement("g", {
  fill: "#E6E9EB"
}, React.createElement("path", {
  d: "M725 216.062A8.001 8.001 0 0 0 726 232a8 8 0 0 0 1-15.938V212a1 1 0 0 0-2 0v4.062z"
}), React.createElement("path", {
  d: "M740 226.07a7.002 7.002 0 0 0 1 13.93 7 7 0 0 0 1-13.93V212a1 1 0 0 0-2 0v14.07z",
  opacity: 0.9
}), React.createElement("path", {
  d: "M755 232.083A6.002 6.002 0 0 0 756 244a6 6 0 0 0 1-11.917V212a1 1 0 0 0-2 0v20.083z",
  opacity: 0.8
}), React.createElement("path", {
  d: "M770 232.1a5.002 5.002 0 0 0 1 9.9 5 5 0 0 0 1-9.9V212a1 1 0 0 0-2 0v20.1z",
  opacity: 0.7
}), React.createElement("path", {
  d: "M785.008 229.124A4.002 4.002 0 0 0 786 237a4 4 0 0 0 .992-7.876A1.01 1.01 0 0 0 787 229v-17a1 1 0 0 0-2 0v17c0 .042.003.083.008.124z",
  opacity: 0.6
}), React.createElement("path", {
  d: "M800 224.17a3.001 3.001 0 1 0 2 0V212a1 1 0 0 0-2 0v12.17z",
  opacity: 0.5
})), React.createElement("g", {
  fill: "#E6E9EB"
}, React.createElement("path", {
  d: "M907 201.938A8.001 8.001 0 0 0 906 186a8 8 0 0 0-1 15.938V206a1 1 0 0 0 2 0v-4.062z"
}), React.createElement("path", {
  d: "M892 191.93a7.002 7.002 0 0 0-1-13.93 7 7 0 0 0-1 13.93V206a1 1 0 0 0 2 0v-14.07z",
  opacity: 0.9
}), React.createElement("path", {
  d: "M877 185.917A6.002 6.002 0 0 0 876 174a6 6 0 0 0-1 11.917V206a1 1 0 0 0 2 0v-20.083z",
  opacity: 0.8
}), React.createElement("path", {
  d: "M862 185.9a5.002 5.002 0 0 0-1-9.9 5 5 0 0 0-1 9.9V206a1 1 0 0 0 2 0v-20.1z",
  opacity: 0.7
}), React.createElement("path", {
  d: "M846.992 188.876A4.002 4.002 0 0 0 846 181a4 4 0 0 0-.992 7.876A1.01 1.01 0 0 0 845 189v17a1 1 0 0 0 2 0v-17a1.01 1.01 0 0 0-.008-.124z",
  opacity: 0.6
}), React.createElement("path", {
  d: "M832 193.83a3.001 3.001 0 1 0-2 0V206a1 1 0 0 0 2 0v-12.17z",
  opacity: 0.5
})), React.createElement("g", null, React.createElement("g", {
  fill: "#99D8F1"
}, React.createElement("path", {
  d: "M380 201.938A8.001 8.001 0 0 1 381 186a8 8 0 0 1 1 15.938V206a1 1 0 0 1-2 0v-4.062z",
  opacity: 0.9
}), React.createElement("path", {
  d: "M365 191.93a7.002 7.002 0 0 1 1-13.93 7 7 0 0 1 1 13.93V206a1 1 0 0 1-2 0v-14.07z",
  opacity: 0.8
}), React.createElement("path", {
  d: "M350 185.917A6.002 6.002 0 0 1 351 174a6 6 0 0 1 1 11.917V206a1 1 0 0 1-2 0v-20.083z",
  opacity: 0.7
}), React.createElement("path", {
  d: "M335 185.9a5.002 5.002 0 0 1 1-9.9 5 5 0 0 1 1 9.9V206a1 1 0 0 1-2 0v-20.1z",
  opacity: 0.6
}), React.createElement("path", {
  d: "M320.008 188.876A4.002 4.002 0 0 1 321 181a4 4 0 0 1 .992 7.876c.005.04.008.082.008.124v17a1 1 0 0 1-2 0v-17c0-.042.003-.083.008-.124z",
  opacity: 0.5
}), React.createElement("path", {
  d: "M305 193.83a3.001 3.001 0 1 1 2 0V206a1 1 0 0 1-2 0v-12.17z",
  opacity: 0.4
})), React.createElement("path", {
  fill: "#99D8F1",
  d: "M290 200.055V199a1 1 0 0 1 2 0v1.055A9.001 9.001 0 0 1 291 218a9 9 0 0 1-1-17.945zM291 139a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0 53a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-20a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-21a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-24a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0 52a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-21a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-25a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-18a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1zm0 71a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-21a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-20a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-24a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1z"
}), React.createElement("g", {
  fill: "#99D8F1"
}, React.createElement("path", {
  d: "M412 216.062A8.001 8.001 0 0 1 411 232a8 8 0 0 1-1-15.938V212a1 1 0 0 1 2 0v4.062z",
  opacity: 0.9
}), React.createElement("path", {
  d: "M427 226.07a7.002 7.002 0 0 1-1 13.93 7 7 0 0 1-1-13.93V212a1 1 0 0 1 2 0v14.07z",
  opacity: 0.8
}), React.createElement("path", {
  d: "M442 232.083A6.002 6.002 0 0 1 441 244a6 6 0 0 1-1-11.917V212a1 1 0 0 1 2 0v20.083z",
  opacity: 0.7
}), React.createElement("path", {
  d: "M457 232.1a5.002 5.002 0 0 1-1 9.9 5 5 0 0 1-1-9.9V212a1 1 0 0 1 2 0v20.1z",
  opacity: 0.6
}), React.createElement("path", {
  d: "M471.992 229.124A4.002 4.002 0 0 1 471 237a4 4 0 0 1-.992-7.876A1.01 1.01 0 0 1 470 229v-17a1 1 0 0 1 2 0v17c0 .042-.003.083-.008.124z",
  opacity: 0.5
}), React.createElement("path", {
  d: "M487 224.17a3.001 3.001 0 1 1-2 0V212a1 1 0 0 1 2 0v12.17z",
  opacity: 0.4
})), React.createElement("path", {
  fill: "#99D8F1",
  d: "M395 217.945V219a1 1 0 1 0 2 0v-1.055A9.001 9.001 0 0 0 396 200a9 9 0 0 0-1 17.945zM396 279a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0-53a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 20a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 21a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 24a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0-52a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 21a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 25a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 18a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0-71a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 21a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 20a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 24a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1z"
}), React.createElement("g", {
  fill: "#E6E9EB"
}, React.createElement("path", {
  d: "M305 216.062A8.001 8.001 0 0 0 306 232a8 8 0 0 0 1-15.938V212a1 1 0 0 0-2 0v4.062z"
}), React.createElement("path", {
  d: "M320 226.07a7.002 7.002 0 0 0 1 13.93 7 7 0 0 0 1-13.93V212a1 1 0 0 0-2 0v14.07z",
  opacity: 0.9
}), React.createElement("path", {
  d: "M335 232.083A6.002 6.002 0 0 0 336 244a6 6 0 0 0 1-11.917V212a1 1 0 0 0-2 0v20.083z",
  opacity: 0.8
}), React.createElement("path", {
  d: "M350 232.1a5.002 5.002 0 0 0 1 9.9 5 5 0 0 0 1-9.9V212a1 1 0 0 0-2 0v20.1z",
  opacity: 0.7
}), React.createElement("path", {
  d: "M365.008 229.124A4.002 4.002 0 0 0 366 237a4 4 0 0 0 .992-7.876A1.01 1.01 0 0 0 367 229v-17a1 1 0 0 0-2 0v17c0 .042.003.083.008.124z",
  opacity: 0.6
}), React.createElement("path", {
  d: "M380 224.17a3.001 3.001 0 1 0 2 0V212a1 1 0 0 0-2 0v12.17z",
  opacity: 0.5
})), React.createElement("g", {
  fill: "#E6E9EB"
}, React.createElement("path", {
  d: "M487 201.938A8.001 8.001 0 0 0 486 186a8 8 0 0 0-1 15.938V206a1 1 0 0 0 2 0v-4.062z"
}), React.createElement("path", {
  d: "M472 191.93a7.002 7.002 0 0 0-1-13.93 7 7 0 0 0-1 13.93V206a1 1 0 0 0 2 0v-14.07z",
  opacity: 0.9
}), React.createElement("path", {
  d: "M457 185.917A6.002 6.002 0 0 0 456 174a6 6 0 0 0-1 11.917V206a1 1 0 0 0 2 0v-20.083z",
  opacity: 0.8
}), React.createElement("path", {
  d: "M442 185.9a5.002 5.002 0 0 0-1-9.9 5 5 0 0 0-1 9.9V206a1 1 0 0 0 2 0v-20.1z",
  opacity: 0.7
}), React.createElement("path", {
  d: "M426.992 188.876A4.002 4.002 0 0 0 426 181a4 4 0 0 0-.992 7.876A1.01 1.01 0 0 0 425 189v17a1 1 0 0 0 2 0v-17a1.01 1.01 0 0 0-.008-.124z",
  opacity: 0.6
}), React.createElement("path", {
  d: "M412 193.83a3.001 3.001 0 1 0-2 0V206a1 1 0 0 0 2 0v-12.17z",
  opacity: 0.5
}))), React.createElement("g", null, React.createElement("g", {
  fill: "#E1D0FF"
}, React.createElement("path", {
  d: "M590 201.938A8.001 8.001 0 0 1 591 186a8 8 0 0 1 1 15.938V206a1 1 0 0 1-2 0v-4.062z",
  opacity: 0.9
}), React.createElement("path", {
  d: "M575 191.93a7.002 7.002 0 0 1 1-13.93 7 7 0 0 1 1 13.93V206a1 1 0 0 1-2 0v-14.07z",
  opacity: 0.8
}), React.createElement("path", {
  d: "M560 185.917A6.002 6.002 0 0 1 561 174a6 6 0 0 1 1 11.917V206a1 1 0 0 1-2 0v-20.083z",
  opacity: 0.7
}), React.createElement("path", {
  d: "M545 185.9a5.002 5.002 0 0 1 1-9.9 5 5 0 0 1 1 9.9V206a1 1 0 0 1-2 0v-20.1z",
  opacity: 0.6
}), React.createElement("path", {
  d: "M530.008 188.876A4.002 4.002 0 0 1 531 181a4 4 0 0 1 .992 7.876c.005.04.008.082.008.124v17a1 1 0 0 1-2 0v-17c0-.042.003-.083.008-.124z",
  opacity: 0.5
}), React.createElement("path", {
  d: "M515 193.83a3.001 3.001 0 1 1 2 0V206a1 1 0 0 1-2 0v-12.17z",
  opacity: 0.4
})), React.createElement("path", {
  fill: "#E1D0FF",
  d: "M500 200.055V199a1 1 0 0 1 2 0v1.055A9.001 9.001 0 0 1 501 218a9 9 0 0 1-1-17.945zM501 139a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0 53a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-20a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-21a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-24a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0 52a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-21a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-25a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-18a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1zm0 71a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-21a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-20a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-24a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1z"
}), React.createElement("g", {
  fill: "#E1D0FF"
}, React.createElement("path", {
  d: "M622 216.062A8.001 8.001 0 0 1 621 232a8 8 0 0 1-1-15.938V212a1 1 0 0 1 2 0v4.062z",
  opacity: 0.9
}), React.createElement("path", {
  d: "M637 226.07a7.002 7.002 0 0 1-1 13.93 7 7 0 0 1-1-13.93V212a1 1 0 0 1 2 0v14.07z",
  opacity: 0.8
}), React.createElement("path", {
  d: "M652 232.083A6.002 6.002 0 0 1 651 244a6 6 0 0 1-1-11.917V212a1 1 0 0 1 2 0v20.083z",
  opacity: 0.7
}), React.createElement("path", {
  d: "M667 232.1a5.002 5.002 0 0 1-1 9.9 5 5 0 0 1-1-9.9V212a1 1 0 0 1 2 0v20.1z",
  opacity: 0.6
}), React.createElement("path", {
  d: "M681.992 229.124A4.002 4.002 0 0 1 681 237a4 4 0 0 1-.992-7.876A1.01 1.01 0 0 1 680 229v-17a1 1 0 0 1 2 0v17c0 .042-.003.083-.008.124z",
  opacity: 0.5
}), React.createElement("path", {
  d: "M697 224.17a3.001 3.001 0 1 1-2 0V212a1 1 0 0 1 2 0v12.17z",
  opacity: 0.4
})), React.createElement("path", {
  fill: "#E1D0FF",
  d: "M605 217.945V219a1 1 0 1 0 2 0v-1.055A9.001 9.001 0 0 0 606 200a9 9 0 0 0-1 17.945zM606 279a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0-53a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 20a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 21a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 24a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0-52a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 21a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 25a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 18a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0-71a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 21a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 20a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 24a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1z"
}), React.createElement("g", {
  fill: "#E6E9EB"
}, React.createElement("path", {
  d: "M515 216.062A8.001 8.001 0 0 0 516 232a8 8 0 0 0 1-15.938V212a1 1 0 0 0-2 0v4.062z"
}), React.createElement("path", {
  d: "M530 226.07a7.002 7.002 0 0 0 1 13.93 7 7 0 0 0 1-13.93V212a1 1 0 0 0-2 0v14.07z",
  opacity: 0.9
}), React.createElement("path", {
  d: "M545 232.083A6.002 6.002 0 0 0 546 244a6 6 0 0 0 1-11.917V212a1 1 0 0 0-2 0v20.083z",
  opacity: 0.8
}), React.createElement("path", {
  d: "M560 232.1a5.002 5.002 0 0 0 1 9.9 5 5 0 0 0 1-9.9V212a1 1 0 0 0-2 0v20.1z",
  opacity: 0.7
}), React.createElement("path", {
  d: "M575.008 229.124A4.002 4.002 0 0 0 576 237a4 4 0 0 0 .992-7.876A1.01 1.01 0 0 0 577 229v-17a1 1 0 0 0-2 0v17c0 .042.003.083.008.124z",
  opacity: 0.6
}), React.createElement("path", {
  d: "M590 224.17a3.001 3.001 0 1 0 2 0V212a1 1 0 0 0-2 0v12.17z",
  opacity: 0.5
})), React.createElement("g", {
  fill: "#E6E9EB"
}, React.createElement("path", {
  d: "M697 201.938A8.001 8.001 0 0 0 696 186a8 8 0 0 0-1 15.938V206a1 1 0 0 0 2 0v-4.062z"
}), React.createElement("path", {
  d: "M682 191.93a7.002 7.002 0 0 0-1-13.93 7 7 0 0 0-1 13.93V206a1 1 0 0 0 2 0v-14.07z",
  opacity: 0.9
}), React.createElement("path", {
  d: "M667 185.917A6.002 6.002 0 0 0 666 174a6 6 0 0 0-1 11.917V206a1 1 0 0 0 2 0v-20.083z",
  opacity: 0.8
}), React.createElement("path", {
  d: "M652 185.9a5.002 5.002 0 0 0-1-9.9 5 5 0 0 0-1 9.9V206a1 1 0 0 0 2 0v-20.1z",
  opacity: 0.7
}), React.createElement("path", {
  d: "M636.992 188.876A4.002 4.002 0 0 0 636 181a4 4 0 0 0-.992 7.876A1.01 1.01 0 0 0 635 189v17a1 1 0 0 0 2 0v-17a1.01 1.01 0 0 0-.008-.124z",
  opacity: 0.6
}), React.createElement("path", {
  d: "M622 193.83a3.001 3.001 0 1 0-2 0V206a1 1 0 0 0 2 0v-12.17z",
  opacity: 0.5
}))), React.createElement("g", null, React.createElement("g", {
  fill: "#99D8F1"
}, React.createElement("path", {
  d: "M1010 201.938a8.001 8.001 0 0 1 1-15.938 8 8 0 0 1 1 15.938V206a1 1 0 0 1-2 0v-4.062z",
  opacity: 0.9
}), React.createElement("path", {
  d: "M995 191.93a7.002 7.002 0 0 1 1-13.93 7 7 0 0 1 1 13.93V206a1 1 0 0 1-2 0v-14.07z",
  opacity: 0.8
}), React.createElement("path", {
  d: "M980 185.917A6.002 6.002 0 0 1 981 174a6 6 0 0 1 1 11.917V206a1 1 0 0 1-2 0v-20.083z",
  opacity: 0.7
}), React.createElement("path", {
  d: "M965 185.9a5.002 5.002 0 0 1 1-9.9 5 5 0 0 1 1 9.9V206a1 1 0 0 1-2 0v-20.1z",
  opacity: 0.6
}), React.createElement("path", {
  d: "M950.008 188.876A4.002 4.002 0 0 1 951 181a4 4 0 0 1 .992 7.876c.005.04.008.082.008.124v17a1 1 0 0 1-2 0v-17c0-.042.003-.083.008-.124z",
  opacity: 0.5
}), React.createElement("path", {
  d: "M935 193.83a3.001 3.001 0 1 1 2 0V206a1 1 0 0 1-2 0v-12.17z",
  opacity: 0.4
})), React.createElement("path", {
  fill: "#99D8F1",
  d: "M920 200.055V199a1 1 0 0 1 2 0v1.055A9.001 9.001 0 0 1 921 218a9 9 0 0 1-1-17.945zM921 139a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0 53a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-20a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-21a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-24a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0 52a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-21a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-25a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-18a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1zm0 71a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-21a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-20a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0-24a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1z"
}), React.createElement("g", {
  fill: "#99D8F1"
}, React.createElement("path", {
  d: "M1042 216.062a8.001 8.001 0 0 1-1 15.938 8 8 0 0 1-1-15.938V212a1 1 0 0 1 2 0v4.062z",
  opacity: 0.9
}), React.createElement("path", {
  d: "M1057 226.07a7.002 7.002 0 0 1-1 13.93 7 7 0 0 1-1-13.93V212a1 1 0 0 1 2 0v14.07z",
  opacity: 0.8
}), React.createElement("path", {
  d: "M1072 232.083a6.002 6.002 0 0 1-1 11.917 6 6 0 0 1-1-11.917V212a1 1 0 0 1 2 0v20.083z",
  opacity: 0.7
}), React.createElement("path", {
  d: "M1087 232.1a5.002 5.002 0 0 1-1 9.9 5 5 0 0 1-1-9.9V212a1 1 0 0 1 2 0v20.1z",
  opacity: 0.6
}), React.createElement("path", {
  d: "M1101.992 229.124A4.002 4.002 0 0 1 1101 237a4 4 0 0 1-.992-7.876A1.01 1.01 0 0 1 1100 229v-17a1 1 0 0 1 2 0v17c0 .042-.003.083-.008.124z",
  opacity: 0.5
}), React.createElement("path", {
  d: "M1117 224.17a3.001 3.001 0 1 1-2 0V212a1 1 0 0 1 2 0v12.17z",
  opacity: 0.4
})), React.createElement("path", {
  fill: "#99D8F1",
  d: "M1025 217.945V219a1 1 0 1 0 2 0v-1.055a9.001 9.001 0 0 0-1-17.945 9 9 0 0 0-1 17.945zm1 61.055a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0-53a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 20a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 21a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 24a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0-52a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 21a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 25a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 18a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0-71a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 21a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 20a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1zm0 24a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1z"
}), React.createElement("g", {
  fill: "#E6E9EB"
}, React.createElement("path", {
  d: "M935 216.062A8.001 8.001 0 0 0 936 232a8 8 0 0 0 1-15.938V212a1 1 0 0 0-2 0v4.062z"
}), React.createElement("path", {
  d: "M950 226.07a7.002 7.002 0 0 0 1 13.93 7 7 0 0 0 1-13.93V212a1 1 0 0 0-2 0v14.07z",
  opacity: 0.9
}), React.createElement("path", {
  d: "M965 232.083A6.002 6.002 0 0 0 966 244a6 6 0 0 0 1-11.917V212a1 1 0 0 0-2 0v20.083z",
  opacity: 0.8
}), React.createElement("path", {
  d: "M980 232.1a5.002 5.002 0 0 0 1 9.9 5 5 0 0 0 1-9.9V212a1 1 0 0 0-2 0v20.1z",
  opacity: 0.7
}), React.createElement("path", {
  d: "M995.008 229.124A4.002 4.002 0 0 0 996 237a4 4 0 0 0 .992-7.876A1.01 1.01 0 0 0 997 229v-17a1 1 0 0 0-2 0v17c0 .042.003.083.008.124z",
  opacity: 0.6
}), React.createElement("path", {
  d: "M1010 224.17a3.001 3.001 0 1 0 2 0V212a1 1 0 0 0-2 0v12.17z",
  opacity: 0.5
})), React.createElement("g", {
  fill: "#E6E9EB"
}, React.createElement("path", {
  d: "M1117 201.938a8.001 8.001 0 0 0-1-15.938 8 8 0 0 0-1 15.938V206a1 1 0 0 0 2 0v-4.062z"
}), React.createElement("path", {
  d: "M1102 191.93a7.002 7.002 0 0 0-1-13.93 7 7 0 0 0-1 13.93V206a1 1 0 0 0 2 0v-14.07z",
  opacity: 0.9
}), React.createElement("path", {
  d: "M1087 185.917a6.002 6.002 0 0 0-1-11.917 6 6 0 0 0-1 11.917V206a1 1 0 0 0 2 0v-20.083z",
  opacity: 0.8
}), React.createElement("path", {
  d: "M1072 185.9a5.002 5.002 0 0 0-1-9.9 5 5 0 0 0-1 9.9V206a1 1 0 0 0 2 0v-20.1z",
  opacity: 0.7
}), React.createElement("path", {
  d: "M1056.992 188.876A4.002 4.002 0 0 0 1056 181a4 4 0 0 0-.992 7.876 1.01 1.01 0 0 0-.008.124v17a1 1 0 0 0 2 0v-17a1.01 1.01 0 0 0-.008-.124z",
  opacity: 0.6
}), React.createElement("path", {
  d: "M1042 193.83a3.001 3.001 0 1 0-2 0V206a1 1 0 0 0 2 0v-12.17z",
  opacity: 0.5
}))), React.createElement("text", {
  fill: "#52585f",
  fontFamily: "Avenir-Roman, Avenir",
  fontSize: 18
}, React.createElement("tspan", {
  x: 30,
  y: 55
}, "Consultation with our "), React.createElement("tspan", {
  x: 30,
  y: 80
}, "Case Coordinator")), React.createElement("text", {
  fill: "#52585f",
  fontFamily: "Avenir-Medium, Avenir",
  fontSize: 18,
  fontWeight: 400
}, React.createElement("tspan", {
  x: 285,
  y: 80
}, "Matching")), React.createElement("text", {
  fill: "#52585f",
  fontFamily: "Avenir-Medium, Avenir",
  fontSize: 18,
  fontWeight: 400
}, React.createElement("tspan", {
  x: 442,
  y: 30
}, "Arrange egg "), React.createElement("tspan", {
  x: 442,
  y: 55
}, "donor\u2019s initial "), React.createElement("tspan", {
  x: 442,
  y: 80
}, "medical screening")), React.createElement("text", {
  fill: "#52585f",
  fontFamily: "Avenir-Medium, Avenir",
  fontSize: 18,
  fontWeight: 400
}, React.createElement("tspan", {
  x: 676,
  y: 30
}, "Egg donor "), React.createElement("tspan", {
  x: 676,
  y: 55
}, "starting simulation "), React.createElement("tspan", {
  x: 676,
  y: 80
}, "medication")), React.createElement("text", {
  fill: "#52585f",
  fontFamily: "Avenir-Medium, Avenir",
  fontSize: 18,
  fontWeight: 400
}, React.createElement("tspan", {
  x: 910,
  y: 55
}, "PGS/PGD "), React.createElement("tspan", {
  x: 910,
  y: 80
}, "embryo screening")), React.createElement("text", {
  fill: "#52585f",
  fontFamily: "Avenir-Medium, Avenir",
  fontSize: 18,
  fontWeight: 400
}, React.createElement("tspan", {
  x: 104,
  y: 349
}, "Choose egg donor")), React.createElement("text", {
  fill: "#52585f",
  fontFamily: "Avenir-Medium, Avenir",
  fontSize: 18,
  fontWeight: 400
}, React.createElement("tspan", {
  x: 338,
  y: 349
}, "Signing Contract")), React.createElement("text", {
  fill: "#52585f",
  fontFamily: "Avenir-Medium, Avenir",
  fontSize: 18,
  fontWeight: 400
}, React.createElement("tspan", {
  x: 818,
  y: 349
}, "Egg Retrieval")), React.createElement("text", {
  fill: "#52585f",
  fontFamily: "Avenir-Medium, Avenir",
  fontSize: 18,
  fontWeight: 400
}, React.createElement("tspan", {
  x: 1008,
  y: 349
}, "Embryo freezing "), React.createElement("tspan", {
  x: 1008,
  y: 374
}, "anwait for the "), React.createElement("tspan", {
  x: 1008,
  y: 399
}, "transfer")), React.createElement("text", {
  fill: "#52585f",
  fontFamily: "Avenir-Medium, Avenir",
  fontSize: 18,
  fontWeight: 400
}, React.createElement("tspan", {
  x: 560,
  y: 349
}, "Medical and legal "), React.createElement("tspan", {
  x: 560,
  y: 374
}, "clearence, ED and IPs "), React.createElement("tspan", {
  x: 560,
  y: 399
}, "sign legal contract")));

var SvgGene = function SvgGene(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 1176,
    height: 418,
    viewBox: "0 0 1176 418",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGene, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gene.f84b377d.svg";
export { ForwardRef as ReactComponent };